export default "__VITE_ASSET__QSjKACRp__"